import * as React from "react";
import { CommonHelper } from "../../../../../react-core/Helpers/CommonHelper";
import { InstructionStatus } from "../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Contents } from "../../../Resoures/Contents";
import { Urls } from "../../../Urls";
import { NoChangeAction } from "./Action/NoChangeAction";
import { Review } from "./Components/Review";
import { stepTitle } from "./Resource/Contents";
import { NoChangeToolStore } from "./Store/Variable";
import { AccountRoleStore, ClientAccountStore } from "../../../Stroes/Variable";
import {
    AccountContextWizardComponent,
    IAccountContextWizardComponentState,
} from "../../../../Shared/Process/AccountContextWizardComponent";
import { RoutingActions } from "../../../../../react-core/Flux/Variables";
import { getUrl } from "../PortfolioDashboard/Components/Common/PortfolioDashboardHelper";
import { HierarchyIdHelper } from "../../../../Shared/Common/HierarchyIdHelper";
import { SPTAction } from "../SinglePaymentTransferWizard/Actions/SPTActions";
import { ProcessType } from "../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";

export class NoChangeToolWizard extends AccountContextWizardComponent<IAccountContextWizardComponentState> {
    initState() {
        this.state = {
            data: null,
            errorMsg: [],
            isShowErrorMsg: false,
            isLoading: true,
            onPosting: false,
            active: true,
            isSubmitting: false,
            isRestrictionLoading: true,
            clientAccount: null,
            customer: null,
        };
    }
    constructor(props: any) {
        super(props);
        this.subscribeToStore(NoChangeToolStore, () => this.onInstructionStoreChange());
    }

    private onInstructionStoreChange() {
        const data = NoChangeToolStore.getData();
        this.setState({
            isLoading: CommonHelper.isNullOrEmpty(data),
            data: data,
            onPosting: false,
            active: data.Status === InstructionStatus.Pending || data.Status === InstructionStatus.NotSpecified,
        });

        SPTAction.postInstructionProcess(
            HierarchyIdHelper.generateHierarchyId(data.HierarchyId).entityId,
            ProcessType.NoChangeTool
        );

        NoChangeAction.submitInstruction(this.state.data?.HierarchyId, () => {
            this.setState({
                isSubmitting: false,
                onPosting: false,
                active: false,
                isShowErrorMsg: false,
                errorMsg: [],
            });
        });

        const { entityId: instructionId } = HierarchyIdHelper.generateHierarchyId(data.HierarchyId);
        NoChangeAction.updateInstructionIsAdHocNoChange(instructionId);
    }

    componentDidUpdate(prevProps) {
        const { clientAccount, customer } = this.state;
        if (clientAccount && customer && !this.state.data) {
            const params = getQueryParameters();
            NoChangeAction.getInstruction(
                params["id"],
                params["hierarchyid"],
                params["subaccounthierarchyid"],
                this.state.customer?.CustomerId,
                this.getCurProductType()
            );
        }
    }

    componentDidMount() {
        super.componentDidMount();
    }

    onSubmit() {}

    saveInstruction(from, to, toUrl, params, stepLength) {}

    onCancel() {
        this.onExit();
    }

    onExit() {
        const accountRoles = AccountRoleStore.getAccountRoles();
        const clientAccount = ClientAccountStore.getClientAccountInfo();
        RoutingActions.navigateTo(getUrl(clientAccount, accountRoles, "summary"));
    }

    private getCurProductType(): SubAccountType {
        const clientInfo = ClientAccountStore.getClientAccountInfo();
        const params = getQueryParameters();
        const productType = (clientInfo.SubAccounts || []).find(
            (ele) => ele.HierarchyId == params["subaccounthierarchyid"]
        )?.SubAccountType;
        return productType;
    }

    getStepProps(index) {
        const stepProps = super.getStepProps(index);
        return stepProps;
    }

    setStepperConfig() {
        const productType = this.getCurProductType();
        const { data } = this.state;
        this.stepperConfig = [
            {
                title: stepTitle.review,
                url: Urls.get().WhatIfToolReview,
                path: Contents.URLMap.review,
                component: <Review {...this.getStepProps(this.stepperConfig.length)} type={productType} />,
            },
        ];
    }

    setProcessProps() {
        const processProps = super.setProcessProps();
        processProps.processTitle = "No Change Tool";
        processProps.needSplitHeader = {
            fromStep: 0,
            splitHeaderMain: `${this.state.customer?.PersonalDetails?.Name?.Given} ${this.state.customer?.PersonalDetails?.Name?.Family}`,
            splitHeaderSub: ClientAccountStore.getClientAccountInfo()?.HeadClAccountId,
        };
        return processProps;
    }
}
